import { Button } from 'antd';
import ApproveIcon from 'assets/images/driver-portal/approval.svg';
import { Text } from 'components';
import { theme } from 'configs/styled';
import Divider from 'containers/DriverPortalPage/components/Divider';
import DriverPortalLayout from 'containers/DriverPortalPage/components/DriverPortalLayout';
import { ImageLogo } from 'containers/DriverPortalPage/components/HeaderPortal.style';
import Loading from 'containers/DriverPortalPage/components/Loading';
import HeaderPortal from 'containers/DriverPortalPage/MainPage/components/HeaderPortal';
import ReturnButton from 'containers/DriverPortalPage/MainPage/components/ReturnButton';
import React from 'react';
import { useQuery } from 'react-fetching-library';
import { Link } from 'react-router-dom';
import { authenticationService } from 'services/driverPortal';
import { IOnlineTrainingResponse } from 'services/driverPortal/DriverPortal.interface';
import Information from '../components/Information';
import ErrorPage from '../ErrorPage';

export interface IOnlineTrainingPageProps {}
const OnlineTrainingPage: React.FC<IOnlineTrainingPageProps> = () => {
  const { userId } = authenticationService.getUserToken();

  const { payload: onlineTraining, error, loading } = useQuery<
    IOnlineTrainingResponse
  >({
    method: 'GET',
    endpoint: '',
  });

  if (error) return <ErrorPage />;

  return (
    <>
      <HeaderPortal
        documentsReviewStatusName={
          onlineTraining?.data?.documentsReviewStatus?.status
        }
      />
      <DriverPortalLayout>
        {loading && <Loading />}
        <ReturnButton />

        <Information title="อบรมออนไลน์" description="" />

        <Divider />

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            margin: `${theme.spacing.xxl} 0`,
            backgroundColor: theme.palettes.primaryBackground,
            height: 184,
          }}
        >
          <div style={{ margin: `${theme.spacing.xxl} 0` }}>
            <ImageLogo style={{ height: 70 }} src={ApproveIcon} />
          </div>
          <Text style={{ fontSize: 28, fontWeight: 400, lineHeight: '38px' }}>
            คุณผ่านการทดสอบ
          </Text>
        </div>

        <Button block type="primary" size="large">
          <Link to="/">กลับหน้าแรก</Link>
        </Button>
      </DriverPortalLayout>
    </>
  );
};

export default OnlineTrainingPage;
